/* eslint-disable @typescript-eslint/no-explicit-any */
import { Flex, Switch, Text } from "@mantine/core";
import { IconPhoto } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { appShowNotification } from "../../utils/utils";
const UsePatientImages = () => {
  const [useImages, setUseImages] = useState<boolean>(false);
  // const [modalOpened, setModalOpened] = useState<boolean>(false);

  useEffect(() => {
    checkUseImages();
  }, []);
  const checkUseImages = async () => {
    const isUseImage = localStorage.getItem("useImages");
    setUseImages(isUseImage == "true");
  };
  const handleToggleImages = async (value: boolean) => {
    try {
      setUseImages(value);
      localStorage.setItem("useImages", value ? "true" : "false");
      appShowNotification({ title: "Changes saved!", type: "success" });
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.warn(error);
    }
  };
  return (
    <Flex
      px={"sm"}
      pos={"relative"}
      align={"center"}
      justify={"space-between"}
      className="box-use-patient-image"
    >
      <Flex align={"center"}>
        <IconPhoto size={"16"} stroke={1.5} />
        <Text ml={10} fz={"var(--mantine-font-size-sm)"}>
          Use patient images
        </Text>
      </Flex>
      <Switch
        checked={useImages}
        fw={600}
        my={10}
        size="xs"
        labelPosition="left"
        onChange={(e) => handleToggleImages(e.currentTarget.checked)}
      />
    </Flex>
  );
};
export default UsePatientImages;
